import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {faUsers} from "@fortawesome/free-solid-svg-icons/faUsers";
import {Observable, Subscription} from "rxjs";
import {FacilityService} from "../services/facility.service";

@Component({
  selector: 'cintas-customer-selection',
  templateUrl: './customer-selection.component.html',
  styleUrls: ['./customer-selection.component.scss']
})
export class CustomerSelectionComponent implements OnInit, OnDestroy {

  customerIcon = faUsers;

  @Input()
  selectedCustomer;

  @Input()
  classString = "";

  @Output()
  customerChange: EventEmitter<any> = new EventEmitter<any>();

  private customers$: Observable<any>;
  private customersSub: Subscription;
  customers: any[];

  constructor(private facilityService: FacilityService) {
  }

  ngOnInit() {
    const fakeData = {
      data: [
        {
          cuid: "cm2xbbips0005dn43we09vfv4",
          __typename: "LaundryCustomer",
          created_at: "2024-07-10T13:33:07+00:00",
          updated_at: "2024-07-10T13:33:07+00:00",
          name: "John Doe",
          label: "John Doe"
        },
        {
          cuid: "cm2xbbips0006dn43n0dezxiu",
          __typename: "LaundryCustomer",
          created_at: "2024-07-10T13:33:07+00:00",
          updated_at: "2024-07-10T13:33:07+00:00",
          name: "Jane Smith",
          label: "Jane Smith"
        },
        {
          cuid: "cm2xbbips0007dn436qvuldri",
          __typename: "LaundryCustomer",
          created_at: "2024-07-10T13:33:07+00:00",
          updated_at: "2024-07-10T13:33:07+00:00",
          name: "Emily Johnson",
          label: "Emily Johnson"
        },
        {
          cuid: "cm2xbbips0008dn43rhhni9n5",
          __typename: "LaundryCustomer",
          created_at: "2024-07-10T13:33:07+00:00",
          updated_at: "2024-07-10T13:33:07+00:00",
          name: "Michael Brown",
          label: "Michael Brown"
        }
      ]
    };

    // Assign the data to customers
    this.customers = fakeData.data;
    console.log(this.customers)
    console.log(fakeData.data)

    // // Instead of calling the service, we directly assign the fake data
    // this.customers = fakeData;
    // this.customers$ = this.facilityService.getCabinetUsers();
    // this.customersSub = this.customers$.subscribe(res => {
    //   this.customers = res.users;
    // });
  }

  ngOnDestroy(): void {
    if (this.customersSub) {
      this.customersSub.unsubscribe();
    }
  }

  onCustomerSelected(customer?) {
    this.selectedCustomer = customer ? customer : null;
    this.customerChange.emit(this.selectedCustomer);
  }

}
